import { actionCreator } from '@ardoq/rxbeach';
import { PayloadShowRelatedComponents } from './types';

export const showScenarioRelatedComponents =
  actionCreator<PayloadShowRelatedComponents>(
    '[scenarioRelated] SHOW_SCENARIO_RELATED_COMPONENTS'
  );
